<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Dupliquer les dossiers pour un nouvel exercice
        </div>

        <div slot="body">
            <p>
                Duplique les dossiers d'un exercice vers un autre exercice si leur cegid n'est pas déjà présent
                dans cet exercice.
            </p>

            <form
                class="row mt-4"
                @submit.prevent="duplicate"
            >
                <div class="col-5">
                    <base-input
                        v-model="params.exercice_a_dupliquer"
                        :errors="errors.exercice_a_dupliquer"
                    >
                        Exercice à dupliquer*
                    </base-input>
                </div>

                <div class="col-5">
                    <base-input
                        v-model="params.nouvel_exercice"
                        :errors="errors.nouvel_exercice"
                    >
                        Nouvel Exercice*
                    </base-input>
                </div>
            </form>
        </div>

        <div slot="footer">
            <button
                v-btn-loading="saving"
                class="btn btn-success mr-2"
                @click="duplicate"
            >
                Enregistrer
            </button>

            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                Annuler
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseInput from "../templates/BaseInput"
    export default {
        name: "DuplicateDossiersModal",
        components: {BaseInput, BaseModal},

        data: function () {
            return {
                saving: false,
                params: {
                    // Pour l'année fiscale (en juin il faut que ça bascule à l'année suivante)
                    exercice_a_dupliquer: (moment().subtract(5, 'months').year()).toString(),
                    nouvel_exercice: (moment().add(7, 'months').year()).toString()
                },
                errors: {}
            }
        },

        methods: {
            /**
             * Duplique les dossiers de l'exercice dans un nouvel exercice
             */
            duplicate: function () {
                this.saving = true
                if (parseInt(this.params.nouvel_exercice) <= parseInt(this.params.exercice_a_dupliquer)) {
                    this.errors.nouvel_exercice = ['Le nouvel exercice doit être supérieur à l\'exercice à dupliquer']
                    this.saving = false
                    return
                }

                axios.post('/api/dossiers/duplicate', this.params).then(() => {
                    this.$notify(
                        'success',
                        "La duplication des dossiers a bien été lancé et devrait se terminer d'ici quelques secondes."
                    )
                    this.$emit('close')
                }).catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$notify('danger', "Une erreur est survenue lors de la duplication des dossiers")
                    }
                }).finally(() => this.saving = false)
            }
        }
    }
</script>
